import api from './api';

// User service
export const userService = {
  async list(params = {}) {
    const response = await api.get('/users/', { params });
    return response.data;
  },

  async create(payload) {
    const response = await api.post('/users/', payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await api.put(`/users/${id}`, payload);
    return response.data;
  },

  async changePassword(id, payload) {
    const response = await api.post(`/users/${id}/change-password`, payload);
    return response.data;
  },

  async resetPassword(id) {
    const response = await api.post(`/users/${id}/reset-password`);
    return response.data;
  },

  async remove(id) {
    // Soft delete: mark inactive
    return this.update(id, { is_active: false });
  },

  async delete(id) {
    // Hard delete
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  async bulkDelete(userIds) {
    // Hard delete multiple users
    const response = await api.delete('/users/bulk', { data: { user_ids: userIds } });
    return response.data;
  },

  async getLoginAttempts(userId, params = {}) {
    const response = await api.get(`/users/${userId}/login-attempts`, { params });
    return response.data;
  },
};